import _objectSpread from "/data/landun/workspace/vft-activities/vip-activity/pages/cny2022-sport/node_modules/@vue/cli-plugin-babel/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.date.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import IconShare from '@tencent/vft-component/IconShare';
import { setUrlParam } from '@tencent/vft-common/util';
import { mapGetters, mapState } from 'vuex';
import env from '@tencent/vft-common/env';
import pop from '@/mixin/pop'; // 海报id配置

var cardIdConfig = {
  bless: 'N4mhjmamC6',
  // 普通分享
  assist: 'LjPRb8qScr',
  // 分享助力
  lottery: 'SSTUwDrkqm' // 抽奖

};
export default {
  mixins: [pop],
  props: {
    value: {
      type: Boolean,
      "default": false
    },
    shareInfo: {
      type: Object,
      "default": function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      base64: '',
      defaultHeadUrl: '//i.gtimg.cn/qqlive/images/20180516/icon120.png'
    };
  },
  components: {
    IconShare: IconShare,
    CloudSealCard: function CloudSealCard() {
      return import('@tencent/cloud-seal-card');
    }
  },
  methods: {
    handleSuccess: function handleSuccess(img) {
      this.base64 = img;
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapGetters(['assistModId'])), mapState(['shareStatus', 'nbaVipIcon'])), {}, {
    params: function params() {
      var url = window.pageSetting.分享链接;
      url = setUrlParam('ptag', "qr.".concat(this.type), url); // 没有助力完成带主态 vuid

      if (!this.shareStatus) {
        url = setUrlParam('mvuid', this.vuid, url);
      }

      console.log("\u5206\u4EAB\u94FE\u63A5: ".concat(url));
      var deadline = this.dateFormat(new Date(), 'yyyy.MM.dd'); // nba 体育图标

      return _objectSpread(_objectSpread({
        headImg: this.userService.headurl || this.defaultHeadUrl,
        nickname: this.userService.nick,
        nbaVipIcon: this.nbaVipIcon ? "<img src=\"".concat(this.nbaVipIcon, "\" class='icon' />") : '',
        qrUrl: url
      }, this.shareInfo), {}, {
        deadline: deadline
      });
    },
    // 分享类型
    type: function type() {
      var type = this.shareInfo.type;
      return type || 'share';
    },
    // 海报id
    cardId: function cardId() {
      return cardIdConfig[this.type];
    },
    showBtn: function showBtn() {
      return env.isApp || env.isQQSports;
    }
  })
};